// extracted by mini-css-extract-plugin
export default {"base":"DetailsView__base___2kdkP","aside":"DetailsView__aside___2u-mH","rightside":"DetailsView__rightside___Yra6Y"};